// Hooks principaux
export {
    useExtensions,
    usePageExtensions,
    useMultipleExtensions,
    useHasExtensions,
    useAllExtensions,
    usePuckExtension,
    usePuckExtensionManagementOptions,
    EXTENSION_QUERY_KEYS,
    type PuckExtension,
    type RuntimePuckExtension,
    type PuckExtensionManagementOptions,
    type PuckExtensionSectorOption,
    type ExtensionContext,
} from "src/api/client-api/puckExtensions/useExtensions";

// Hooks de mutation
export {
    useCreatePuckExtension,
    useUpdatePuckExtension,
    useDeletePuckExtension,
    type CreatePuckExtensionRequest,
    type UpdatePuckExtensionRequest,
} from "src/api/client-api/puckExtensions/usePuckExtensionMutations";

// Composants de rendu
export { PuckExtensionRenderer, withExtensionErrorBoundary } from "./PuckExtensionRenderer";

export { ExtensionPoint, ConditionalExtensionPoint, LazyExtensionPoint, useExtensionPoint } from "./ExtensionPoint";

// Extension points prédéfinis pour faciliter l'usage
export const EXTENSION_POINTS = {
    // Global
    GLOBAL_HEADER: "global.header",
    GLOBAL_FOOTER: "global.footer",

    // Dashboard
    DASHBOARD_SIDEBAR_TOP: "dashboard.sidebar.top",
    DASHBOARD_SIDEBAR_BOTTOM: "dashboard.sidebar.bottom",

    // Questionnaire
    QUESTIONNAIRE_BEFORE: "questionnaire.before",
    QUESTIONNAIRE_AFTER: "questionnaire.after",

    // Pages Product
    PRODUCT_LISTING_HEADER: "product.listing.header",
    PRODUCT_LISTING_FOOTER: "product.listing.footer",

    // Pages Product Detail scores
    PRODUCT_DETAIL_SCORE_HEADER: "product.detail.score.header",
    PRODUCT_DETAIL_SCORE_FOOTER: "product.detail.score.footer",

    // Pages Product Detail questionnaire
    PRODUCT_DETAIL_QUESTIONNAIRE_HEADER: "product.detail.questionnaire.header",
    PRODUCT_DETAIL_QUESTIONNAIRE_FOOTER: "product.detail.questionnaire.footer",

    // Pages Product Detail information
    PRODUCT_DETAIL_INFORMATION_HEADER: "product.detail.information.header",
    PRODUCT_DETAIL_INFORMATION_FOOTER: "product.detail.information.footer",

    // Pages Ingredient
    INGREDIENT_LISTING_HEADER: "ingredient.listing.header",
    INGREDIENT_LISTING_FOOTER: "ingredient.listing.footer",

    // Pages Ingredient Detail scores
    INGREDIENT_DETAIL_SCORE_HEADER: "ingredient.detail.score.header",
    INGREDIENT_DETAIL_SCORE_FOOTER: "ingredient.detail.score.footer",

    // Pages Ingredient Detail questionnaire
    INGREDIENT_DETAIL_QUESTIONNAIRE_HEADER: "ingredient.detail.questionnaire.header",
    INGREDIENT_DETAIL_QUESTIONNAIRE_FOOTER: "ingredient.detail.questionnaire.footer",

    // Pages Ingredient Detail information
    INGREDIENT_DETAIL_INFORMATION_HEADER: "ingredient.detail.information.header",
    INGREDIENT_DETAIL_INFORMATION_FOOTER: "ingredient.detail.information.footer",

    // Pages Ingredient Detail activity
    INGREDIENT_DETAIL_ACTIVITY_HEADER: "ingredient.detail.activity.header",
    INGREDIENT_DETAIL_ACTIVITY_FOOTER: "ingredient.detail.activity.footer",

    // Pages Packaging
    PACKAGING_LISTING_HEADER: "packaging.listing.header",
    PACKAGING_LISTING_FOOTER: "packaging.listing.footer",

    // Pages Supplier
    SUPPLIER_LISTING_HEADER: "supplier.listing.header",
    SUPPLIER_LISTING_FOOTER: "supplier.listing.footer",

    // Pages Product Form - Ingredients step
    PRODUCT_FORM_INGREDIENTS_HEADER: "product.form.ingredients.header",
    PRODUCT_FORM_INGREDIENTS_FOOTER: "product.form.ingredients.footer",

    // Action plan invitation, between the greeting and the proposed plan
    ACTION_PLAN_INVITATION_AFTER_CONTEXT: "action.plan.invitation.after_context",

    // Pages Company
    COMPANY_SCORES_HEADER: "company.scores.header",
    COMPANY_SCORES_SIDEBAR: "company.scores.sidebar",
    COMPANY_SCORES_FOOTER: "company.scores.footer",
    COMPANY_OVERVIEW_BANNER: "company.overview.banner",
} as const;

export type ExtensionPointKey = keyof typeof EXTENSION_POINTS;
export type ExtensionPointValue = (typeof EXTENSION_POINTS)[ExtensionPointKey];
